import React, { useState } from 'react';
import { PlusIcon } from './icons';
import { Pill } from './Pill';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-blush py-10 sm:py-12" aria-labelledby="faq-heading" data-id="element-45" data-mp="1blu0uonhre7e">
      <div className="mx-auto max-w-3xl px-6" data-id="element-46" data-mp="1gkerbwcxyjin">
        <div className="text-center" data-id="element-47" data-mp="24969rw0qbni8">
          <Pill data-id="element-48" data-mp="24a92m9hm400s">Before you decide</Pill>
          <h2 id="faq-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-49" data-mp="24bao77w984wr">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-9 space-y-3" data-id="element-50" data-mp="1zihm6rs67aod">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-2xl border bg-cream transition-colors duration-150 ease-out ${isOpen ? 'border-gold/60' : 'border-rose-deep/25'}`} data-id="element-51" data-mp="2n7aac22jwe8f" data-mpi={index}>
                <h3 data-id="element-52" data-mp="10tys28wgb623">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-2xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wine" data-id="element-53" data-mp="10ui0mz07oi3g">
                    <span className="font-display text-xl leading-snug text-charcoal" data-id="element-54" data-mp="1xjzcxwtp92e4">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-wine text-cream' : 'bg-rose-light text-wine'}`} aria-hidden="true" data-id="element-55" data-mp="1sm67j6080cew">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-56" data-mp="1ybfzyuz7tanx" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-57" data-mp="2c6jfv4xotlr0">
                  <div className="overflow-hidden" data-id="element-58" data-mp="2vx4ykgj21af6">
                    <p className="px-6 pb-6 font-sans text-[0.95rem] leading-relaxed text-ash" data-id="element-59" data-mp="2vyy8q5svmcrx">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}